"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceNumbers = exports.Services = void 0;
var Services;
(function (Services) {
    Services["ARREARS"] = "Arrears";
    Services["CLAIM"] = "Claim";
    Services["DEFAULT"] = "Default";
    Services["DOCUMENT"] = "Document";
    Services["LENDER"] = "Lender";
    Services["LOAN"] = "Loan";
    Services["USER"] = "User";
    Services["PORTAL"] = "Portal";
})(Services = exports.Services || (exports.Services = {}));
exports.ServiceNumbers = (_a = {},
    // Modules
    _a[Services.USER] = 1,
    _a[Services.ARREARS] = 2,
    _a[Services.CLAIM] = 3,
    _a[Services.DEFAULT] = 4,
    // Non-Module Services
    _a[Services.PORTAL] = 101,
    _a[Services.DOCUMENT] = 102,
    _a[Services.LOAN] = 103,
    _a[Services.LENDER] = 104,
    _a);
